import {useState} from "react"
import {useTranslation} from "react-i18next"
import {CopyBlock, dracula} from "react-code-blocks"
import {MEDIA_URL} from "../../constants/apiUrls"
import EcpTabChoice from "../../components/ecp-tab-choice/EcpTabChoice"

export default function EcpWorkflowIntegration({project}) {
    const {t} = useTranslation()
    const [tabs, setTabs] = useState([])

    const handleSelect = (value) => {
        setTabs(tabs.includes(value) ? tabs.filter(v => v !== value) : [...tabs, value])
    }

    const queryString = tabs.map(tab => encodeURIComponent(tab)).join("&")

    return (
        <>
        <div className="SECTION ECP-WORKFLOW-INTEGRATION">
            <div className="ecp-workflow-content">
                <span className="integration">
                    <p>{t("Web integration code:")}</p>
                    <CopyBlock
                        text={`<iframe src="${MEDIA_URL}/${project.id}/html/${project.lang_code}.html${queryString && "?" + queryString}" title="${project.title} | neurowide-ecp"></iframe>`}
                        language={"html"}
                        theme={dracula}
                        customStyle={{
                            display: "flex",
                            height: "50px",
                            borderRadius: "10px",
                            fontSize: "16px",
                        }}
                    />
                </span>
                <EcpTabChoice handleSelect={handleSelect} tabs={tabs}/>
                <iframe src={`${MEDIA_URL}/${project.id}/html/${project.lang_code}.html${queryString && "?" + queryString}`} title="HTML API Preview" width="100%" height="500"/>
            </div>
        </div>
        </>
    )
}